<span class="center-align">
    <span *ngIf="percent">{{data.PERCENT}}%</span>
    <a *ngIf="id" (click)="navigate(data.MSTR_MDM_ID)">{{data.MSTR_MDM_ID}}</a>
    <a *ngIf="name" (click)="navigate(data.MSTR_MDM_ID)">{{data.MSTR_PLAN_NAME}}</a>
</span>
<div *ngIf="sources" class="zs-display-flex source-col">
    <span *ngFor="let source of data.SOURCES; let i=index"
        [ngStyle]="{'background-color': environment.mdmSourceColorCodes[source.trim().toLowerCase()]}"
        class="zs-badge-counter zs-badge-counter-new">{{ source.trim().toUpperCase() }}</span>
</div>